import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Carousel from 'components/ResourcesCarousel';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import ResourceItemSelector from 'components/ResourceItemSelector';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Mixpanel from 'utils/mixpanelService';
import { ButtonBase } from '@material-ui/core';
import HorizontalTopicCard from './HorizontalTopicCard';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
    marginLeft: -4,
    maxWidth: 'calc(100% + 8px) !important',
    width: 'calc(100% + 8px) !important',
  },
  topicWrapper: {
    paddingTop: 4,
    paddingBottom: 4,
    '&:first-child': {
      paddingTop: 0,
    },
    '&:last-child': {
      paddingBottom: 0,
    },
  },
});

const ResultList = ({
  isMobile,
  isTablet,
  isDesktop,
  resources,
  topics,
  isFullWidth,
  assessment,
  entryId,
  labelValue,
}) => {
  const classes = useStyles();
  const carouselRef = useRef();
  const location = useLocation();
  const isTabletOrLess = useMediaQuery('(max-width:768px)');
  const [assessmentResultsConfig] = useSiteCopySelector(['assessment-results']);

  // const getSlide = useCallback(() => {
  //   const storedLabel = sessionStorage.getItem('currentAccordion');
  //   const storedType = sessionStorage.getItem('currentListType');
  //   const storedSlide = sessionStorage.getItem('currentListSlide');
  //   if (
  //     storedLabel === `dynamic-id-${labelValue}` &&
  //     storedType === 'ResultList' &&
  //     storedSlide != null
  //   ) {
  //     // sessionStorage.removeItem('currentListSlide');
  //     return storedSlide;
  //   }
  //   return 0;
  // }, [labelValue]);

  // const getCurrentSlide = useCallback(() => {
  //   if (carouselRef.current) {
  //     const { state } = carouselRef.current;
  //     return state.currentSlide;
  //   }
  //   return null;
  // }, []);

  const onClickInterceptCallback = () => {
    sessionStorage.setItem('currentAccordionHandled', true);
    sessionStorage.setItem('currentAccordion', `dynamic-id-${labelValue}`);
    sessionStorage.setItem('currentListType', 'ResultList');
    sessionStorage.removeItem('currentListSlug');
    // sessionStorage.setItem('currentListSlide', getCurrentSlide());
    sessionStorage.removeItem('currentListSlide');
    sessionStorage.setItem('scrollY', window.scrollY);
  };

  useEffect(() => {
    if (carouselRef.current) {
      // const goTo = getSlide();
      carouselRef.current.goToSlide(0);
    }
  }, [resources]);

  if (_isEmpty(resources)) return null;

  const slidesToSlide = isMobile
    ? 1
    : isTablet
    ? 2
    : isDesktop || !isFullWidth
    ? 3
    : 4;

  const setRef = el => {
    carouselRef.current = el;
  };

  const initialResources = resources.slice(0, slidesToSlide - 1);
  const finalResources = resources.slice(slidesToSlide - 1);

  const header = _get(assessmentResultsConfig, 'callToAction');

  const handleCarouselRightClick = () => {
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';

    Mixpanel.track('Resources Carousel - Slide Right Clicked', {
      assessment,
      page: finalPageName,
      path: location.pathname.split('/')[1],
      slug: location.pathname.split('/')[2],
      entryId,
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography align="left" variant="h6" color="textPrimary">
          {header}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Carousel
          setRef={setRef}
          bigArrow
          slidesToSlide={slidesToSlide}
          swipeable
          isSmallCard
          small={isTabletOrLess}
          arrowRightClickHandler={handleCarouselRightClick}
          responsive={{
            largaDesktop: {
              breakpoint: {
                max: 4000,
                min: 1300,
              },
              items: !isFullWidth ? 3 : 4,
            },
            desktop: {
              breakpoint: {
                max: 1300,
                min: 800,
              },
              items: 3,
            },
            tablet: {
              breakpoint: {
                max: 800,
                min: 480,
              },
              items: 2,
            },
            mobile: {
              breakpoint: {
                max: 480,
                min: 0,
              },
              items: 1,
            },
          }}
        >
          {initialResources.map((el, index) => {
            const fromContentful = _has(el, 'fields');
            const finalId = fromContentful ? el.sys.id : el.objectID;
            return (
              <ButtonBase disableRipple onClick={onClickInterceptCallback}>
                <ResourceItemSelector
                  key={finalId}
                  item={el}
                  itemIndex={index}
                />
              </ButtonBase>
            );
          })}
          {topics.length > 0 && (
            <Grid container>
              {topics.slice(0, 3).map(el => (
                <Grid
                  item
                  xs={12}
                  key={_get(el, 'fields.slug')}
                  className={classes.topicWrapper}
                >
                  <ButtonBase disableRipple onClick={onClickInterceptCallback}>
                    <HorizontalTopicCard
                      item={el}
                      isBigCard={topics.length < 3}
                    />
                  </ButtonBase>
                </Grid>
              ))}
            </Grid>
          )}
          {finalResources.map((el, index) => {
            const fromContentful = _has(el, 'fields');
            const finalId = fromContentful ? el.sys.id : el.objectID;
            return (
              <ButtonBase disableRipple onClick={onClickInterceptCallback}>
                <ResourceItemSelector
                  key={finalId}
                  item={el}
                  itemIndex={index}
                />
              </ButtonBase>
            );
          })}
        </Carousel>
      </Grid>
    </Grid>
  );
};

ResultList.propTypes = {
  isFullWidth: PropTypes.bool,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  isDesktop: PropTypes.bool,
  resources: PropTypes.array,
  labelValue: PropTypes.string,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isTablet: width <= 800,
  isDesktop: width <= 1300,
});

export default withSizes(mapSizesToProps)(ResultList);
